import { useQuery } from '@apollo/client';

import UserThirdPartyOrganizationsQuery from 'bundles/authentication/queries/UserThirdPartyOrganizationsQuery.graphql';
import type {
  ThirdPartyOrganizations_SsoInformationFragment as Organization,
  UserThirdPartyOrganizationsQuery as UserThirdPartyOrganizationsData,
  UserThirdPartyOrganizationsQueryVariables,
} from 'bundles/authentication/queries/__generated__/UserThirdPartyOrganizationsQuery';

export type ThirdPartyOrganizationsData = {
  organizations: Array<Organization | null>;
};

const useUserThirdPartyOrganizationsQuery = (slug: string): ThirdPartyOrganizationsData => {
  const { data } = useQuery<UserThirdPartyOrganizationsData, UserThirdPartyOrganizationsQueryVariables>(
    UserThirdPartyOrganizationsQuery,
    {
      skip: !slug,
      variables: { slug },
      context: { clientName: 'gatewayGql' },
    }
  );

  const organizations = data?.NaptimeQueries?.ThirdPartyOrganizationsV1Resource?.bySlug?.elements || [];

  return { organizations };
};

export default useUserThirdPartyOrganizationsQuery;
